var TYPE = "MENU_CONFIG";
export var isMenuConfigMessage = function isMenuConfigMessage(m) {
  return (m === null || m === void 0 ? void 0 : m.type) === TYPE;
};

/**
 * An event message used for configuring the menu component
 *
 * Note: This is a temporary solution to pass the configuration from the shell to the Menu-mfe, A more
 * long term solution would be to fetch this configuration directly from the backend.
 */
export var menuConfigMessage = function menuConfigMessage(payload) {
  return {
    type: TYPE,
    payload: payload
  };
};